<template>
    <header class="head">
        <div class="logo" @click="$router.push('/')">
            <img src="https://pg.yxle.net/ca144a63-2cfb-4333-9ddb-831185ac7b53.png" alt="">
            <h1>app分发平台</h1>
        </div> 
        <div class="user-info">
             <el-dropdown trigger="click" @command="handleCommand">
                <div class="avatar">
                    <img src="https://pg.yxle.net/13cb0c3c-de8b-4543-a7da-d5663b044610.png" alt="">
                </div>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>
    </header>
</template>
<script>
export default {
    methods: {
        handleCommand(command) {
            if(command == 'logout') {
                localStorage.removeItem('token');
                this.$router.push('/login');
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .head {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100%;
        height: 60px;
        background-color: rgb(84, 92, 100);
        padding: 0 2.5%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .logo {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: #fff;
            font-size: 12px;

            img {
                display: block;
                width: 50px;
            }
        }

        .avatar {
            cursor: pointer;
            
            img {
                display: block;
                width: 40px;
            }
        }
    }
</style>